<template>
  <div class="partner-listing">
    <br/><br/><br/><br/>
    <div class="align-self-center text-center">
      <h1>Redirecting to dashboard</h1>
    </div>
    <div class="spinner-container d-flex justify-content-center">
      <b-spinner id="spinner" variant="primary" label="Redirecting to dashboard"></b-spinner>
    </div>
  </div>
</template>

<script>
import SetupEngineAxiosMixin from "@packages/integrations/mixins/SetupEngineAxiosMixin";
import FormErrorsMixin from "@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin";
import {pageRedirect} from "@helpers/router-helper";

export default {
  name: "PartnerListing",

  mixins: [
    FormErrorsMixin,
    SetupEngineAxiosMixin,
  ],

  data: () => ({
    loading: false,
  }),

  async created() {
    return pageRedirect('/dashboard')
  },
}
</script>